import { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Collapse from 'bootstrap/js/dist/collapse'
import Navbar from '../layout/Navbar'

function Header() {
  const { pathname } = useLocation()
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const collapseRef = useRef(null)

  const closeMobileMenu = useCallback(() => {
    const menu = document.getElementById('mainNavbar')
    if (!menu?.classList.contains('show') || !collapseRef.current) return
    collapseRef.current.hide()
  }, [])

  const toggleMobileMenu = useCallback(() => {
    if (!collapseRef.current) return
    if (isMenuOpen) collapseRef.current.hide()
    else collapseRef.current.show()
  }, [isMenuOpen])

  useEffect(() => {
    closeMobileMenu()
  }, [pathname, closeMobileMenu])

  useEffect(() => {
    const menu = document.getElementById('mainNavbar')
    if (!menu) return undefined

    collapseRef.current = Collapse.getOrCreateInstance(menu, { toggle: false })

    const onShow = () => setIsMenuOpen(true)
    const onHide = () => setIsMenuOpen(false)

    menu.addEventListener('shown.bs.collapse', onShow)
    menu.addEventListener('hidden.bs.collapse', onHide)

    return () => {
      menu.removeEventListener('shown.bs.collapse', onShow)
      menu.removeEventListener('hidden.bs.collapse', onHide)
      collapseRef.current?.dispose()
      collapseRef.current = null
    }
  }, [])

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 12)
    onScroll()
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header className={`corp-header corp-header-light ${isScrolled ? 'is-scrolled' : ''}`}>
      <Navbar
        isMenuOpen={isMenuOpen}
        onToggleMenu={toggleMobileMenu}
        onCloseMenu={closeMobileMenu}
      />
    </header>
  )
}

export default Header
